import { useEffect } from "react";

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(id: string, data: object | null) {
  const old = document.getElementById(id);
  if (old) old.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function usePageSeo(title: string, description: string, jsonLd?: { id: string; data: object } | null) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (jsonLd) setJsonLd(jsonLd.id, jsonLd.data);
    window.scrollTo(0, 0);
    return () => {
      if (jsonLd) setJsonLd(jsonLd.id, null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description]);
}

export function useTitle(title: string) {
  useEffect(() => {
    document.title = title;
    window.scrollTo(0, 0);
  }, [title]);
}